import styled from 'styled-components'
import { badgeRanking } from 'util/legacy'
import { useLocalization } from 'localization'

const TopBadgesWrapper = styled.div`
  flex-shrink: 0;
  margin-bottom: 0.8rem;
`

const TopBadge = styled.img`
  width: ${(props) => props.size};
  height: ${(props) => props.size};

  &:not(:first-child) {
    margin-left: 0.8rem;
  }
`

const TopBadges = (props) => {
  const { t } = useLocalization()

  return (
    <TopBadgesWrapper>
      {badgeRanking(props.badges)
        .slice(0, 4)
        .map((badge) => (
          <TopBadge
            key={badge.id}
            src={badge.thumbnail_url}
            size={props.size ? props.size : '3rem'}
            alt={t('dweb_top_badges_alt_top_earned_badges')}
          />
        ))}
    </TopBadgesWrapper>
  )
}

export default TopBadges
